import { EgpRegionAndCountry } from '../egp.service';

import { Pipe, PipeTransform } from '@angular/core';

import { isNil } from 'src/utils/utils';

@Pipe({
  name: 'showRiskbox',
  standalone: true,
})
export class ShowRiskboxPipe implements PipeTransform {
  transform(region: EgpRegionAndCountry, isPigeonCustomer: boolean): boolean {
    if (isPigeonCustomer) {
      return false;
    }

    if (
      isNil(region?.country) ||
      (region.country !== 'de' && region.country !== 'ch')
    ) {
      return false;
    }
    return true;
  }
}
